<template>
  <div class="page">
    <h1 class="h1--underline">
      {{ $tv('guideDetailTitle', 'guide') + ' | ' + guideTitle }}
    </h1>
    <div
      v-for="step in guide?.Steps"
      :key="step?.id"
    >
      <Step :step="step" />
    </div>
    <NuxtLink
      :to="guidePath"
      class="k-button k-button-md k-button-solid k-button-solid-base"
    >
      <NavigationChevronLeft class="svg-navigation-chevron-left" />
      <span class="page__button--content">{{ $tv('go-back-button', 'guide') }}</span>
    </NuxtLink>
  </div>
</template>

<script>
import {useGuideService} from '~/composables/guide_service'
import Step from '~/components/guide/Step.vue'
import NavigationChevronLeft from '~/assets/icons/navigation_chevron_left.svg?component'
import useI18nExtended from '~/composables/usei18nExtended'

function getTranslationParams(i18n, guideData) {
  let translatedParams = {}
  for (let localeCode of i18n.localeCodes.value) {
    if (localeCode !== i18n.locale) {
      let localizedEntity = guideData?.localizations?.find(l => l.locale === localeCode)
      if (localizedEntity) {
        translatedParams[localeCode] = {guideDetail: localizedEntity.Url}
        if (localizedEntity?.guide_categories?.length > 0) {
          translatedParams[localeCode] = {...translatedParams[localeCode], guideCategories: localizedEntity.guide_categories[0].Url}
        }
      }
    }
  }

  return translatedParams
}

export default {
  name: 'GuideDetail',
  components: {
    Step,
    NavigationChevronLeft
  },
  async setup({payload}) {
    const i18n = useI18nExtended()
    const {getGuideByUrl} = useGuideService()
    const route = useRoute()
    const params = route?.params
    const nuxtApp = useNuxtApp()

    const guidePath = nuxtApp.vueApp.localePath('/guides')

    if (payload) {
      return {guide: payload, lang: i18n.locale, params, guidePath}
    }
    let guideData = nuxtApp.payload?.data[`guides_${i18n.locale.value}_{"field":"Url","operator":"contains","value":"${params.guideDetail}"}_true`]
    if (guideData && params.guideDetail) {
      guideData = guideData?.find(n => n.Url.toLowerCase() === params.guideDetail.toLowerCase())
    }
    if (!guideData) {
      guideData = await getGuideByUrl(params.guideDetail, i18n.locale, true)
    }

    if (guideData) {
      let translatedParams = getTranslationParams(i18n, guideData)

      if (Object.entries(translatedParams)?.length > 0) {
        route.meta.nuxtI18n = translatedParams
      }

      return {guide: guideData, lang: i18n.locale, params, guidePath}
    }

    throw showError({statusCode: 404, message: 'Page not found for Guide: ' + params.guideDetail + ', route: ' + route.fullPath})
  },
  mounted() {
    useBreadcrumb(this.breadcrumbs)
  },
  computed: {
    breadcrumbs() {
      return [{label: this.$te('breadcrumbs.guides') ? this.$tv('guides', 'breadcrumbs') : this.$options.name, path: '/guides'},
        {label: this.$tv(this.guide?.guide_categories[0]?.Title, 'breadcrumbs'), path: `/guides/${encodeURIComponent(this.guide?.guide_categories[0]?.Url)}`},
        {label: this.$tv(this.guide?.Title, 'breadcrumbs'), path: `/guides/${encodeURIComponent(this.guide?.guide_categories[0]?.Url)}/${encodeURIComponent(this.guide?.Url)}`}]
    },
    guideTitle() {
      return this.guide?.Title ?? ''
    }
  },
  head() {
    return {
      meta: [{hid: 'robots', name: 'robots', content: 'noindex'}]
    }
  }
}
</script>

<style lang="scss" scoped>
.k-button {
  margin-top: $default-margin-padding-2x;
  margin-bottom: $default-margin-padding-width;

  .svg-navigation-chevron-left {
    font-size: 1.5rem;
    margin-left: -.3em;
    margin-right: .5em;
  }
}
</style>
